var appExperimente = angular.module('ui-experimente-app', ['ui-beneficiario-app', 'ui-ec-app']);

appExperimente.run(['$rootScope', '$uibModal', function ($rootScope, $uibModal) {

  $rootScope.trialModal = function (modalTitle, modalText, trialArea) {
    $uibModal.open({
      templateUrl: '/portal/app/UI-Comum/partials/modals/experimente-modal.html',
      controller: 'TrialModalController',
      // size: 'lg',
      resolve: {
        modalTitle: function () {
          return modalTitle;
        },
        modalText: function () {
          return modalText;
        },
        trialArea: function () {
          return trialArea;
        }
      }
    });
  };

  $rootScope.trialWelcomeModal = function (modalTitle, modalText, trialArea) {
    $uibModal.open({
      templateUrl: '/portal/app/UI-Comum/partials/modals/experimente-modal-boas-vindas.html',
      controller: 'TrialModalController',
      // size: 'lg',
      resolve: {
        modalTitle: function () {
          return modalTitle;
        },
        modalText: function () {
          return modalText;
        },
        trialArea: function () {
          return trialArea;
        }
      }
    });
  };

  $rootScope.isInTrial = function () {
    return true;
  };

  $rootScope.getActiveEstablishment = function () {
    return {
      cnpj: '01132478000642',
      nome: 'SUPER ANDREAZZA',
      pathLogotipo: null,
      tipo: 'Loja',
      filteredCnpj: '001.132.478/0006-42',
      dadosDeNegocio: {
        "cnpj": "01132478000642",
        "razaoSocial": "IRMÃOS ANDREAZZA LTDA",
        "nomeFantasia": "SUPER ANDREAZZA",
        "inscricaoEstadual": "ISENTO",
        "inscricaoMunicipal": "",
        "tipoEstabelecimento": "Loja",
        "endereco": {
          "cep": "95084-180",
          "tipoLogradouro": "RUA",
          "logradouro": "MARIO PEZZI",
          "numero": "770",
          "cidade": "CAXIAS DO SUL",
          "uf": "RS",
          "complemento": null
        },
        "contatos": [
          {
            "nome": "HELENA",
            "nomeMeio": "",
            "sobrenome": "PICOLI",
            "ddd": "54",
            "ramal": "",
            "telefone": "32261011",
            "emailPrincipal": "",
            "emailSecundario": "",
            "cargo": null
          },
          {
            "nome": "JAIME JOSE ANDREAZZA",
            "nomeMeio": "",
            "sobrenome": "JAIME JOSE ANDREAZZA",
            "ddd": "54",
            "ramal": "",
            "telefone": "32081299",
            "emailPrincipal": "LURDES@SUPERANDREAZZA.COM.BR",
            "emailSecundario": "",
            "cargo": null
          },
          {
            "nome": "LUCIANE",
            "nomeMeio": "",
            "sobrenome": "PRABELA",
            "ddd": "54",
            "ramal": "",
            "telefone": "32261011",
            "emailPrincipal": "",
            "emailSecundario": "",
            "cargo": null
          },
          {
            "nome": "JAIME JOSE ANDREAZZA",
            "nomeMeio": "",
            "sobrenome": "JAIME JOSE ANDREAZZA",
            "ddd": "54",
            "ramal": "",
            "telefone": "32081299",
            "emailPrincipal": "LURDES@SUPERANDREAZZA.COM.BR",
            "emailSecundario": "",
            "cargo": null
          },
          {
            "nome": "HELENA",
            "nomeMeio": "",
            "sobrenome": "PICOLI",
            "ddd": "54",
            "ramal": "",
            "telefone": "32261011",
            "emailPrincipal": "",
            "emailSecundario": "",
            "cargo": null
          }
        ],
        "representantes": [
          {
            "nomeCompleto": "JAIME JOSE ANDREAZZA",
            "rg": "1015838566",
            "cpf": "34469958034",
            "dataNascimento": "30/01/2009"
          }
        ],
        "dadosBancarios": [
          {
            "idDadoBancario": "1",
            "numeroBanco": "237",
            "numeroAgencia": "3103",
            "digitoAgencia": "",
            "numeroConta": "1315358",
            "digitoConta": "2",
            "produto": {
              "id": 27,
              "nome": "VR Alimentação",
              "produtoAlimentacao": true,
              "produtoRefeicao": false
            }
          }
        ],
        "dadosQualificacao": {
          "categoria": "REFEICAO",
          "subcategoria": "PIZZARIA",
          "numeroMesas": 0,
          "numeroCadeiras": 0,
          "lugaresBalcao": 0,
          "numerosAtendentes": 0,
          "numeroMaximoRefeicaoDia": 0,
          "areaEstabelecimento": 2,
          "quantidadeCaixasLoja": 30,
          "diasFuncionamento": 2,
          "horaAbertura": "0800",
          "horaFechamento": "1900",
          "possuiDelivery": false,
          "dddDelivery": "",
          "telefoneDelivery": "UNDEFINED"
        }
      }
    };
  };

}]);



/**
 * Início controllers EC
 */
